import { kongApi } from 'packages/common/helpers/api';

const api = kongApi({
  baseURL: `${process.env.VUE_APP_BASE_URL_PERSONNEL_DEPARTMENT}/`,
});

export default {
  generateUnemploymentInsurance(unemploymentInsurance) {
    return api.post('arquivos-governo/seguro-desemprego', unemploymentInsurance, { responseType: 'blob' });
  },
};
